import React from 'react';
import { getVideoPitchPreviewUrl, getVideoThumbnailUrl } from '../../utils/videoEmbed';

export const VideoPlayIcon: React.FC<{ className?: string }> = ({
  className = 'h-14 w-14 text-white/90 drop-shadow-lg',
}) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
    <path d="M8 5v14l11-7z" />
  </svg>
);

/** Opens video pitch in a new tab when clicked. */
export const VideoPitchTile: React.FC<{
  url: string;
  companyThumbnailUrl?: string;
  onLinkClick: () => void;
  preferVideoThumbnail?: boolean;
}> = ({ url, companyThumbnailUrl, onLinkClick, preferVideoThumbnail = true }) => {
  const href = url.startsWith('http') ? url : `https://${url}`;
  const previewUrl = preferVideoThumbnail
    ? getVideoPitchPreviewUrl(url, companyThumbnailUrl)
    : (companyThumbnailUrl && companyThumbnailUrl.trim()) || getVideoThumbnailUrl(url) || null;

  return (
    <div className="!mt-6 !mb-6">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative block w-full aspect-[16/9] rounded-xl overflow-hidden shadow-2xl transition-transform active:scale-[0.98] border border-gray-800"
        onClick={onLinkClick}
      >
        <div className="absolute inset-0 bg-[#222]">
          {previewUrl ? (
            <img
              src={previewUrl}
              alt=""
              className="absolute inset-0 h-full w-full object-cover opacity-60 transition-opacity group-hover:opacity-80"
              loading="lazy"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-gray-800 to-black">
              <VideoPlayIcon />
            </div>
          )}
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 p-6 text-center">
          <VideoPlayIcon />
          <span className="text-xl font-bold tracking-wide text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            View video pitch
          </span>
        </div>
      </a>
    </div>
  );
};
